export default {
  computed: {
    parent() {
      let parent = this.$parent;
      let parentName = parent.$options.name;
      while (parentName !== "personnel") {
        parent = parent.$parent;
        parentName = parent.$options.name;
      }
      return parent;
    },
    multiple() {
      return this.parent.multiple;
    }
  }
};
